import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Button, message, Select } from 'antd';
import { oneKlicks } from '../../SDK/oneclick';
import { OneKlicksFileSDK } from '../../SDK/OneKlicksFileSDK';

const { Option } = Select;

const EditBannerModal = ({ visible, data, onCancel, onSuccess }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [imageUrl, setImageUrl] = useState('');
    const [imageId, setImageId] = useState('');
    const [imagePreview, setImagePreview] = useState(null);

    useEffect(() => {
        if (visible && data) {
            form.setFieldsValue({
                name: data.banner_name,
                status: data.status || 'active',
            });
            setImageId(data.image || '');
            setImageUrl(data.image || '');
            setImagePreview(data.image ? process.env.REACT_APP_API_BASE_LIVE_URL + data.image : null);
        }
    }, [visible, data, form]);

    const handleSubmit = async (values) => {
        try {
            setLoading(true);
            if (!imageId) {
                message.error('Please upload an image');
                return;
            }
            const tableSchema = '';
            const tableName = 'banners';
            const conditions = { id: data.id };
            const bannerData = {
                banner_name: values.name,
                imageId: imageId,
                imageUrl: imageUrl,
                status: values.status || 'active',
            };
            const response = await oneKlicks.update(tableSchema, tableName, bannerData, conditions);
            if (response.success) {
                message.success('Banner updated successfully');
                onSuccess();
            } else {
                message.error('Failed to update banner');
            }
        } catch (error) {
            console.error('Error updating banner:', error);
            message.error('Failed to update banner');
        } finally {
            setLoading(false);
        }
    };

    const handleImageChange = async (e) => {
        const file = e.target.files[0];
        if (file && file.type.startsWith('image/') && file.size <= 2 * 1024 * 1024) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setImagePreview(reader.result);
            };
            reader.readAsDataURL(file);
            // Upload file to server
            const root = 'banners';
            const status = 'publish';
            const uploadResult = await OneKlicksFileSDK.uploadFile(root, status, file);
            if (!uploadResult || !uploadResult.fileId) {
                message.error('Failed to upload image');
                return;
            }
            setImageId(uploadResult.fileId);
            // Use the API base URL for preview and storage
            const bannerurl = `${uploadResult.file.root}/${uploadResult.file.fileName}`;
            setImageUrl(bannerurl);
        } else {
            message.error('Please upload a valid image (max 2MB).');
        }
    };

    const handleCancel = () => {
        form.resetFields();
        setImageUrl('');
        setImageId('');
        setImagePreview(null);
        onCancel();
    };

    return (
        <Modal
            title="Edit Banner"
            open={visible}
            onCancel={handleCancel}
            footer={null}
            width={600}
            destroyOnClose
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={handleSubmit}
                initialValues={{
                    status: 'active',
                }}
            >
                <Form.Item
                    name="name"
                    label="Name"
                    rules={[{ required: true, message: 'Please enter name' }]}
                >
                    <Input placeholder="Enter name" />
                </Form.Item>
                <Form.Item
                    name="status"
                    label="Status"
                >
                    <Select placeholder="Select status">
                        <Option value="active">Active</Option>
                        <Option value="inactive">Inactive</Option>
                    </Select>
                </Form.Item>
                <Form.Item
                    label="Banner Image"
                    required
                >
                    <input type="file" accept="image/*" onChange={handleImageChange} />
                    {imagePreview && (
                        <div style={{ marginTop: '8px' }}>
                            <img src={imagePreview} alt="Banner" style={{ maxWidth: '100%', maxHeight: '200px' }} />
                        </div>
                    )}
                    <p style={{ fontSize: '12px', color: '#666', marginTop: '8px' }}>
                        Upload a new image for the banner (max 2MB, JPG, PNG, GIF)
                    </p>
                </Form.Item>
                <Form.Item style={{ marginBottom: 0, textAlign: 'right' }}>
                    <Button onClick={handleCancel} style={{ marginRight: 8 }}>
                        Cancel
                    </Button>
                    <Button type="primary" htmlType="submit" loading={loading}>
                        Update Banner
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default EditBannerModal; 
